
import './App.css';
import React from 'react';
import Page from './components/nav'



function App() {
  
  return (
    <div className="App">
      <Page/> 
    </div>
  )
}

export default App;
